import axios from 'axios'

export default {
	getAll() {
		return axios.get(window.dtServerUrl + '/realtime')
	},
	clearCall(call) {
		return axios.post(window.dtServerUrl + `/realtime/clearcall`, call)
	},
	getSipCaptureById(id) {
		return axios.get(window.dtServerUrl + `/realtime/${id}/sipcapture`).then((response) => {
			return response?.data
		})
	}
}
